<template>
  <div v-if="arkidian.usuario" class="card card-arkidian">
    <div style="padding:20px">
      <h3>{{ arkidian.alias }}</h3>
      <h6>{{arkidian.edad}} años</h6>

      <arkidian style="width:150px" class="card-img-top" :preferencias="preferencias"></arkidian>

      <div class="card-body">
        <div style="text-align:left">
          <p>Usuario</p>
          <h5>{{ arkidian.usuario }}</h5>

          <p>Contraseña</p>
          <h5>{{ arkidian.password }}</h5>
        </div>
      </div>
      <b-button
        @click="modalArkidian()"
        style="width:100%; margin-bottom:10px"
        pill
        variant="warning"
      >Editar</b-button>
      <br />

    </div>

    <b-modal ref="arkidian-modal" hide-footer title="Editar Arkidian">
      <div class="d-block text-left">
        <p>Usuario</p>
        <h5>{{arkidianModal.usuario}}</h5>
        <p>Password</p>
        <input class="form-control" v-model="password" />

        <p>Sobrenombre</p>
        <input class="form-control" v-model="alias" />

        <p>Fecha de nacimiento</p>
        <b-form-datepicker id="example-datepicker" v-model="fecha" class="mb-2"></b-form-datepicker>
      </div>
      <div v-if="mensaje_modal" class="alert alert-danger" role="alert">{{mensaje_modal}}</div>

      <b-button class="mt-2" variant="warning" block @click="modificar()">Modificar</b-button>
      <b-button class="mt-2" variant="danger" block @click="eliminarModal">Eliminar</b-button>
    </b-modal>

    <b-modal ref="eliminar-modal" hide-footer title="Eliminar Arkidian">
      <div class="d-block text-center">
        <h5>Vas a eliminar el Arkidian</h5>
        <h4>{{arkidian.alias}}</h4>
      </div>
      <b-button class="mt-3" variant="danger" block @click="eliminar()">Eliminar</b-button>
      <b-button class="mt-2" variant="warning" block @click="cerrarEliminar">Cerrar</b-button>
    </b-modal>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import Arkidian from "../shared/Arkidian";

export default {
  props: ["arkidian"],
  data() {
    return {
      mensaje_modal: null,
      preferencias: {
        color: "",
        body: "",
        face: "",
        hair: "",
        avatar: "",
        animated: false
      },
      password: "",
      alias: "",
      fecha: "",
      avatarM: "",
      arkidianModal: {},
      avatars: [
        { imagen: "images/arkidians/ark1.svg", selected: false },
        { imagen: "images/arkidians/ark2.svg", selected: false },
        { imagen: "images/arkidians/ark3.svg", selected: false },
        { imagen: "images/arkidians/ark4.svg", selected: false },
        { imagen: "images/arkidians/ark5.svg", selected: false },
        { imagen: "images/arkidians/ark6.svg", selected: false },
        { imagen: "images/arkidians/ark7.svg", selected: false },
        { imagen: "images/arkidians/ark8.svg", selected: false },
        { imagen: "images/arkidians/ark9.svg", selected: false },
        { imagen: "images/arkidians/ark10.svg", selected: false },
        { imagen: "images/arkidians/ark11.svg", selected: false },
        { imagen: "images/arkidians/ark12.svg", selected: false }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "categorias",
      "userLogged",
      "pathAPI",
      "challengeSeleccionado"
    ])
  },
  components: {
    arkidian: Arkidian
  },
  methods: {
    ingresarComoArkidian() {
      //   this.$store.state.challengeSeleccionado = challenge
      //   this.$router.push({path:'/Desafio'})
    },

    eliminarModal(curso) {
      this.$refs["arkidian-modal"].hide();

      this.$refs["eliminar-modal"].show();
    },
    cerrarEliminar() {
      this.$refs["eliminar-modal"].hide();
    },
    modalArkidian() {
      this.password = this.arkidian.password;
      this.alias = this.arkidian.alias;
      this.avatarM = this.arkidian.avatar;
      this.fecha = this.arkidian.fecha_nacimiento;

      this.arkidianModal = this.arkidian;
      this.$refs["arkidian-modal"].show();
    },

    cerrarModal() {
      this.$refs["arkidian-modal"].hide();
    },

    eliminar() {
      fetch(this.pathAPI + "hijos.php?usuario=" + this.arkidian.usuario, {
        method: "DELETE"
      }).then(() => {
        this.arkidian.usuario = null;
      });
    },

    modificar() {
      var bodyApi;
      (bodyApi =
        "usuario=" +
        this.arkidian.usuario +
        "&alias=" +
        this.alias +
        "&fecha_nacimiento=" +
        this.fecha +
        "&password=" +
        this.password +
        "&avatar=images/arkidians/profile.svg"),
        fetch(this.pathAPI + "hijos.php?" + bodyApi, {
          method: "PUT",
          headers: new Headers({
            "Content-Type": "application/x-www-form-urlencoded"
          })
        })
          .then(response => response.json())
          .then(data => {
            if (data.resultado == "ERROR") {
              this.mensaje_modal = data.mensaje;
            } else {
              console.log(data);
              this.arkidian.password = this.password;
              this.arkidian.alias = this.alias;
              this.arkidian.avatar = this.avatarM;
              this.arkidian.fecha_nacimiento = this.fecha;
              this.arkidian.edad = data.edad;
              this.$refs["arkidian-modal"].hide();
            }
          })

          .catch(() => {
            //console.log("error")
          });
    }
  },
  mounted: function() {
    console.log("Armado del cuerpo");
    if (this.arkidian.arkidian_usuario[0]) {
      this.preferencias.body = this.arkidian.arkidian_usuario[0].cuerpo;
      this.preferencias.color =
        "fill:#" + this.arkidian.arkidian_usuario[0].color;
      this.preferencias.hair = this.arkidian.arkidian_usuario[0].pelo;
      this.preferencias.face = this.arkidian.arkidian_usuario[0].cara;
    } else {
      console.log(this.preferencias);
    }
  }
};
</script>

<style scoped>
p {
  margin: 0px;
}
.card-arkidian {
  border-radius: 15px !important;
  border: 0px !important;
  align-items: center;
  transition: 0.2s;
  z-index: 0;
  margin: 10px;
  background-color: #ececec;
}

.card-arkidian:hover {
  box-shadow: -1px 11px 16px 1px rgba(0, 0, 0, 0.32);
  transition: 0.2s;
  transform: scaleX(1.05) scaleY(1.05);
  z-index: 1;
}

@media screen and (max-width: 600px) {
  .card-arkidian {
    width: 250px;
    margin: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/arkidian/ArkidianComplete.vue